import { Component, ViewChild, ElementRef } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import * as moment from 'moment';

@Component({
  selector: 'app-date-picker-cell-editor',
  template: `
    <mat-form-field appearance="fill" class="w-full">
      <input #input matInput [matDatepicker]="picker" [value]="date" 
             [min]="minDate" (dateChange)="onDateChange($event)" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  `,
  styles: [`.w-full { width: 100%; }`]
})
export class DatePickerCellEditorComponent implements ICellEditorAngularComp {
  private params: any;
  public date: Date | null = null;
  public minDate: Date;
  @ViewChild('input', { static: true }) input!: ElementRef;

  constructor() {
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
  }

  agInit(params: any): void {
    this.params = params;
    this.date = params.value ? new Date(params.value) : null;
    
    if(this.params.data?.originalEndDate) {
      this.minDate = new Date(this.params.data.originalEndDate);
      this.minDate.setHours(0, 0, 0, 0);
    }

    if (this.date && this.date < this.minDate) {
      this.date = new Date(this.minDate);
    }
  }

  getValue(): any {
    return this.date ? moment(this.date).format('YYYY-MM-DD') : null;
  }

  onDateChange(event: any) {
    if (event.value && event.value < this.minDate) {
      this.date = new Date(this.minDate);
    } else {
      this.date = event.value;
    }
    console.log("onDateChange: Selected date=", this.date);

    // Commit the value to the grid immediately
    if (this.date) {
      this.params.api.stopEditing(); // Save the value and stop editing
      this.params.node.setDataValue(this.params.column, this.getValue()); // Update row data
    }
  }

  afterGuiAttached?(): void {
    setTimeout(() => this.input.nativeElement.focus());
  }
}